const IconView = ({ imgSrc }: any) => (
  <div className="consultation-detail-avatar-container">
    <img className="consultation-detail-avatar" src={imgSrc}></img>
  </div>
);

export default IconView;
